import * as React from 'react';
import { Fragment } from 'react';
import { components, MenuProps } from 'react-select';

import { ISelectorValue, UISizeEnum } from '../../../../../../types/shell';
import { ActionButton } from '../../../../buttons';

import styles from './MenuWithSelect.module.scss';

interface IProps {
  onSelect?: (e: any) => void;
  disabled?: boolean;
}

const MenuWithSelect =
  ({ onSelect, disabled }: IProps) =>
  (selectMenuProp: MenuProps<ISelectorValue>) => {
    const { children } = selectMenuProp;

    const handleSelect = () => {
      const value = selectMenuProp.getValue();
      selectMenuProp.selectProps.onMenuClose?.();
      onSelect?.(value);
    };

    return (
      <components.Menu {...selectMenuProp}>
        <Fragment>
          {children}
          <div className={styles.controlsContainer}>
            <ActionButton
              className={styles.selectBtn}
              onClick={handleSelect}
              disabled={disabled}
              size={UISizeEnum.Small}
            >
              Select
            </ActionButton>
          </div>
        </Fragment>
      </components.Menu>
    );
  };

export default MenuWithSelect;
